var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8663 14.1556V12.1397C17.8671 10.7772 17.3988 9.45426 16.5373 8.38482C15.6758 7.31539 14.4714 6.56198 13.1189 6.24643C13.1292 6.20734 13.1372 6.1677 13.1429 6.12771V3.48011C13.1429 3.18307 13.0224 2.8982 12.8081 2.68817C12.5938 2.47813 12.3031 2.36014 12 2.36014C11.6969 2.36014 11.4062 2.47813 11.1919 2.68817C10.9776 2.8982 10.8571 3.18307 10.8571 3.48011V6.12771C10.8628 6.1677 10.8708 6.20734 10.8811 6.24643C9.52859 6.56198 8.32418 7.31539 7.46268 8.38482C6.60117 9.45426 6.13295 10.7772 6.13371 12.1397V14.1556C6.13371 16.8279 4 17.4954 4 18.8315C4 19.4957 4 20.1676 4.61486 20.1676H19.3851C20 20.1676 20 19.4957 20 18.8315C20 17.4954 17.8663 16.8279 17.8663 14.1556Z",
    fill: "#1F2A37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36914 21.2876C8.67232 21.9854 9.17816 22.5804 9.82373 22.9986C10.4693 23.4169 11.2261 23.6398 12 23.6398C12.7739 23.6398 13.5307 23.4169 14.1763 22.9986C14.8218 22.5804 15.3277 21.9854 15.6309 21.2876H8.36914Z",
    fill: "#1F2A37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7a5bc5d6bad18159a3c01b63f1b2e08d.svg";
export { ForwardRef as ReactComponent };